/** @format */

const template = `
<article class="courseunit cu-color-study-draft">
  <div class="courseunit-top-row">
    <div class="credits-box">
      <span class="credit-amount">{{:: $ctrl.customStudyDraft.credits | decimalNumber }}</span>
      <span class="credit-abbreviation" translate="SIS_COMPONENTS.CREDIT_RANGE.CREDITS_ABBR">op</span>
    </div>
    <div class="title-box">
      <span ng-if=":: (!$ctrl.infoModalLinkDisabled)" class="courseunit-code">
        <button
          type="button"
          class="link-button"
          ng-click="$ctrl.openInfoModal()"
          aria-label="{{:: 'CUSTOM_STUDY_DRAFT.OPEN_INFO_MODAL_ANCHOR_TEXT' | translate}} {{:: $ctrl.customStudyDraft.name}} {{:: 'ARIA_LABEL.OPEN_INFO' | translate}}">
          <sis-icon icon="brochure"></sis-icon><span translate="CUSTOM_STUDY_DRAFT.OPEN_INFO_MODAL_ANCHOR_TEXT"></span>
        </button>
      </span>
      <span ng-if=":: $ctrl.infoModalLinkDisabled" class="courseunit-code">
        <sis-icon icon="brochure"></sis-icon>
        <span translate="CUSTOM_STUDY_DRAFT.OPEN_INFO_MODAL_ANCHOR_TEXT"></span>
      </span>
      <sis-tooltip [tooltip-text]="$ctrl.customStudyDraft.name">
        <span class="courseunit-title sis-tooltip-trigger-content"> {{:: $ctrl.customStudyDraft.name}} </span>
      </sis-tooltip>
    </div>
    <ng-transclude></ng-transclude>
  </div>
</article>
`;
export default template;
